import React from 'react';

interface Props {
  message: string;
}

export const ErrorMessage: React.FC<Props> = ({ message }) => {
  return (
    <div className="flex width-100% items-center gap-4xs margin-top-3xs">
      <svg
      className='icon icon--xs'
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path
          stroke="#232323"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M8 4.323v4.451M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12Z"
        />
        <path
          stroke="#232323"
          d="M7.996 11.678a.29.29 0 1 1 0-.581M7.996 11.678a.29.29 0 1 0 0-.581"
        />
      </svg>

      <span className="text-sm">{message}</span>
    </div>
  );
};
